// https://github.com/tc39/proposal-global
var $export = require('./_export');

$export($export.S, 'System', { global: require('./_global') });



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/core-js/modules/es7.system.global.js
// module id = zQT/
// module chunks = 1